
var worldInfoMixin = {
    methods: {
      selectRegionWorlds: function (regionName) {
        var worldsArrays={
            SAWDC:SAWDC_WORLDS_ARRAY,
            CAW:CAW_WORLDS_ARRAY,
            WAW:WAW_WORLDS_ARRAY,
            NAW:NAW_WORLDS_ARRAY,
            EAW:EAW_WORLDS_ARRAY,
            NCTEJW:NCTEJW_WORLDS_ARRAY

  
          }
          return worldsArrays[regionName]
      }
    }
  };


  export default worldInfoMixin;


/*########################################################################################################*/
/*########################################################################################################*/
/*########################################################################################################*/
var SAWDC_WORLDS_ARRAY=[
    {
      file_name_url: 'aerospace',
      
      },
      {
       // name:'Construction',
      file_name_url:'construction',
      },
      {
       // name:'Energy',
        file_name_url:'energy',
    
      },
      {
   
        file_name_url:'engineering_and_design',
    
      },
      {
       
        file_name_url:'healthcare',
    
      },
      {
      
        file_name_url:'information_technology',
     },
      {
        file_name_url:'hospitality_and_tourism',
       },
  
      {
  
        file_name_url:'manufacturing',
     },
      {
       
        file_name_url:'public_service',
        },
      {
       
        file_name_url:'safety',
     },
      {
       
        file_name_url:'shipbuilding_and_repair',
     },
      {
       // name: 'Su',
        file_name_url:'transportation_distribution_and_logistics',
      },
    ]


/*########################################################################################################*/
/*########################################################################################################*/
/*########################################################################################################*/
var WAW_WORLDS_ARRAY=[
    {
       // name: 'agriculture',
        file_name_url:'agriculture',
      },
      {
       // name:'cosmetology',
        file_name_url:'cosmetology',
      },
      {
       // name:'construction',
        file_name_url:'construction',
    
      },
      {
       // name:'education',
        file_name_url:'education',
    
      },
      {
       // name:'energy_and_utilities',
        file_name_url:'energy_and_utilities',
    
      },
      {
       // name:'engineering_and_environment',
        file_name_url:"engineering_and_environment",
     },   {
       // name:  'healthcare',
        file_name_url:'healthcare',
       },
      {
       // name:  'hospitality_and_tourism',
        file_name_url:'hospitality_and_tourism',
       },

      {
       // name:'manufacturing_auto_logistics',
        file_name_url:'manufacturing_auto_logistics',
     },
      {
       // name:'public_safety',
        file_name_url:'public_safety',
        },
      {
       // name: 'transportation',
        file_name_url:'transportation',
     },
    
    ]

/*########################################################################################################*/
/*########################################################################################################*/
/*########################################################################################################*/
var EAW_WORLDS_ARRAY=[
    {
       // name: 'agriculture_and_natural_resources',
        file_name_url:'agriculture_and_natural_resources',
      },
      {
       // name:'automotive_and_manufacturing',
        file_name_url:'automotive_and_manufacturing',
      },
      {
       // name:'communications_media_and_marketing',
        file_name_url:'communications_media_and_marketing',
    
      },
      {
       // name:'construction',
        file_name_url:'construction',
    
      },
      {
       // name:'energy_and_utilities',
        file_name_url:'energy_and_utilities',
    
      },
      {
       // name:'engineering',
        file_name_url:"engineering",
     },   {
       // name:  'healthcare',
        file_name_url:'healthcare',
       },
      {
       // name:  'information_technology',
        file_name_url:'information_technology',
       },

      {
       // name:'public_safety',
        file_name_url:'public_safety',
     },

      {
       // name: 'transportation',
        file_name_url:'transportation_distribution_and_logistics',
     },
    
    ]
    /*########################################################################################################*/
/*########################################################################################################*/
/*########################################################################################################*/
var CAW_WORLDS_ARRAY=[

  {
   // name:  'manufacturing',
    file_name_url:'manufacturing',
   },
     
   {
   // name:'healthcare',
    file_name_url:'healthcare',
   },
   {
   // name:'architecture_construction_and_utilities',
    file_name_url:'architecture_construction_and_utilities',
  },
  {
   // name:'communication_and_information_technology',
    file_name_url:'communication_and_information_technology',

  },
  {
   // name: 'transportation_distribution_and_logistics',
    file_name_url:'transportation_distribution_and_logistics',
 },
    {
       // name: 'agriculture',
        file_name_url:'agriculture',
      },


      {
       // name:'education_and_training',
        file_name_url:'education_and_training',
    
      },

      {
       // name:'hospitality_and_tourism',
        file_name_url:'hospitality_and_tourism',
       },

      {
       // name:'public_service',
        file_name_url:'public_service',
     },


    
    ]
    /*########################################################################################################*/
/*########################################################################################################*/
/*########################################################################################################*/
var NAW_WORLDS_ARRAY=[

      {
       // name:'aerospace',
        file_name_url:'aerospace',
    
      },
      {
       // name:'agriculture',
        file_name_url:'agriculture_food_and_natural_resources',
    
      },
      {
       // name:'architecture',
        file_name_url:'architecture_and_construction',
    
      },

      {
       // name:'Advanced Manufacturing',
        file_name_url:'modern_manufacturing',
      },
      {
       // name:'automotive andmanufacturing',
        file_name_url:'modern_manufacturing_auto',
       },
      {
       // name:  'business and finance',
        file_name_url:'business_and_finance',
       },

      {
       // name:'public_service',
        file_name_url:'communications_media_and_marketing',
     },

      {
       // name: 'Cybersecurity and Information Technology',
        file_name_url:'cybersecurity_and_information_technology',
     },
     {
       // name: 'Education & Training',
        file_name_url:'education_and_training',
     },
     {
       // name: 'Energy & Utilities',
        file_name_url:'energy_and_utilities',
     },
     {
        //name: 'Healthcare',
        file_name_url:'healthcare',
     },
     {
        //name: 'Hospitality & Tourism',
        file_name_url:'hospitality_and_tourism',
     },
     {
        //name: 'Law, Public Safety, Correction and Security',
        file_name_url:'law_public_safety_and_corrections',
     },
     {
        //name: 'Transportation,Distribution & Logistics',
        file_name_url:'transportation_distribution_and_logistics',
     },
    ]

 /*********************** */
 var NCTEJW_WORLDS_ARRAY=[
  {
    file_name_url:'agriculture',
  

  },
  {
    file_name_url:'biotechnology',


  },
  {
    file_name_url:'construction',

  },
  {
    file_name_url:'energy_and_technology',
   

  },


  {
    file_name_url:'healthcare',
  
 },
  {
    file_name_url:'hospitality_tourism_and_retail',

   },

  {
    file_name_url:'manufacturing',

 },
  {
    file_name_url:'public_works_and_safety',
  
    },


  {
    file_name_url: 'transportation_and_logistics',

  },
]

